import React, { useCallback } from "react";
import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";
import { useAppContext } from "../../hooks/useAppContext";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useLabels } from "../../hooks/useLabels";
import { useSnackbar } from "../../hooks/useSnackbar";
import { showSaveAndConfirmDialogAsync } from "../dialogs/save-dialog";
import { FloatingMenuItem } from "./floating-menu-item";
import { labels } from "./labels";

export function SaveMenuItem() {
	const [[save, saveNotification], areLabelsLoading] = useLabels([
		labels.save,
		labels.saveNotification,
	]);

	const {
		context: { account },
		editor,
		googleAnalytics,
	} = useAppContext();
	const { busyBlocker } = useBusyBlockerContext();
	const { createErrorHandler } = useErrorHandling();
	const { addSnackbar } = useSnackbar();

	const onSave = useCallback(() => {
		googleAnalytics.trackEventToGa({ trackingAction: "SaveProject" });

		const saveAsync = () =>
			showSaveAndConfirmDialogAsync({
				editor,
				busyBlocker,
				getIsSignedIn: () => account?.type === eXpress.core.AccountType.Full,
			});

		saveAsync()
			.then((data) => {
				if (data && saveNotification) {
					addSnackbar({
						id: "save",
						text: saveNotification,
					});
				}
			})
			.catch(createErrorHandler());
	}, [
		account?.type,
		addSnackbar,
		busyBlocker,
		createErrorHandler,
		editor,
		googleAnalytics,
		saveNotification,
	]);

	if (areLabelsLoading) return null;

	return <FloatingMenuItem text={save} iconName="save" onClick={onSave} />;
}
